import {
  params,
  arrayOf,
  string,
  fragment,
  shape,
  bool,
  extend,
  customType,
  typename,
  number
} from '@thd-nucleus/data-sources';
import { MedioInline, PiccolaPencil } from '@thd-olt-component-react/internal-marketing-banner';
import { BrandHero } from '@thd-olt-component-react/hero';
import { CapabilityCard } from '@thd-olt-component-react/capability_card';
import { CalloutCard } from '@thd-olt-component-react/callout_card';
import { ProductShelf } from '@thd-olt-component-react/product-shelf';
import { Resource } from '@thd-olt-component-react/resource';
import { Spotlight } from '@thd-olt-component-react/spotlight';
import { ContentGalleryCard } from '@thd-olt-component-react/content-gallery-card';
import { PromoVisualNavigation, VisualNavigation } from '@thd-olt-component-react/visual-navigation';
import { ComponentSelector, Slot } from '@thd-olt-component-react/component-selector';
import { SideNavigation } from '@thd-olt-component-react/side-navigation';
import { Endcap } from '@thd-olt-component-react/endcap';
import { SpotlightRichText } from '@thd-olt-component-react/spotlight_rich_text';
import { ContentAccordion } from '@thd-olt-component-react/content-accordion';

Slot.dataModel = {
  component: params({
    id: string().isRequired(),
    componentClass: customType('ComponentClass')
      .enum(['Slot'])
      .isRequired(),
  }).shape({
    Slot: fragment().shape({
      componentName: string(),
      id: string(),
      name: string(),
      slotNumber: number(),
      content: shape({
        ...BrandHero.dataModel.component,
        ...Spotlight.dataModel.component,
        ...Resource.dataModel.component,
      })
    })
  })
};

ComponentSelector.dataModel = {
  component: params({
    id: string().isRequired(),
    componentClass: customType('ComponentClass').enum(['ComponentSelector']).isRequired(),
  }).shape({
    ComponentSelector: fragment().shape({
      componentName: string(),
      id: string(),
      targetingType: shape({
        AdobeTarget: fragment().shape({
          id: string(),
          mbox: string()
        }),
        MultiArmBandit: fragment().shape({
          id: string(),
          campaignId: string()
        })
      }),
      defaultComponent: arrayOf(
        shape({
          ...BrandHero.dataModel.component,
          ...Slot.dataModel.component
        })
      ),
      variations: arrayOf(
        shape({
          ...BrandHero.dataModel.component,
          ...Slot.dataModel.component
        })
      ),
    }),
  }),
};

const dynamicSectionsFragment = {
  id: string(),
  title: string(),
  isCarousel: bool(),
  components: arrayOf(shape({
    ...ComponentSelector.dataModel.component,
    ...PromoVisualNavigation.dataModel.component,
    ...MedioInline.dataModel.component,
    ...ProductShelf.dataModel.component,
    ...Spotlight.dataModel.component,
    ...PiccolaPencil.dataModel.component,
    ...Resource.dataModel.component,
    ...Endcap.dataModel.component,
    ...ContentGalleryCard.dataModel.component,
    ...VisualNavigation.dataModel.component,
    ...SpotlightRichText.dataModel.component,
    ...CalloutCard.dataModel.component,
    ...ContentAccordion.dataModel.component,
    ...CapabilityCard.dataModel.component,
  })),
  __typename: string(),
};

const hybridPLPDataModel = fragment().shape({
  id: string(),
  pageType: string(),
  // you need this here too because the query is shaped at a lower level
  // it doesnt magically know how to merge the two heroCarousels because the nesting is odd
  heroCarousel: shape({
    __typename: typename('HeroCarousel'),
    id: string(),
    isCarousel: bool(),
    isAutoplay: bool(),
    components: arrayOf(shape({
      ...BrandHero.dataModel.component,
    })),
  }),
  dynamicSections: arrayOf(shape({ ...dynamicSectionsFragment }))
});

export const hybridLayoutDataModel = extend({
  layouts: params({
    slug: string().isRequired(),
    customerType: string()
  }).shape({
    id: string(),
    slug: string(),
    type: string(),
    content: shape({
      __typename: string(),
      HybridPLPLayout: hybridPLPDataModel
    }),
  }),
},
// you need this here too because the query is asked for at the root level
BrandHero,
ProductShelf,
Resource,
Spotlight,
VisualNavigation,
MedioInline,
PiccolaPencil,
ComponentSelector,
ContentGalleryCard,
SideNavigation,
PromoVisualNavigation,
SpotlightRichText,
Endcap,
Slot,
CalloutCard,
ContentAccordion,
CapabilityCard
);
